import React from "react";
import Grid from '@material-ui/core/Grid';
import { API } from '../config/config';
import axios from 'axios';
import { Spiner } from '../Spinner/Spinner';



export default class Rouls extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            text: ''
        }
    }


    async componentDidMount() {
        this.setState({ loading: true });
        const formData = new FormData();
        formData.append('id', 3);

        try {

            let responseinfo = await axios.post(API + '/api/Contents/List', formData);
            // console.log('market')
            console.log(responseinfo)
            if (responseinfo.status === 200) {
                // console.log(responseinfo.data.results[0].fulltext);
                this.setState({ text: responseinfo.data.results[0].fulltext })
            } else {
                console.log('get-market-error');
                console.log(responseinfo);
                alert('متاسفانه مشکلی در دریافت اطلاعات بوجود آمده لطفا دوباره سعی نمایید.');
            }
        } catch (err) {
            alert('متاسفانه مشکلی در دریافت اطلاعات بوجود آمده لطفا دوباره سعی نمایید.');
        }
        this.setState({ loading: false })


    }

    render() {
        const { loading, text } = this.state;
        return (
            <div className="pages contentpage">
                {loading && <Spiner />}
                <Grid container spacing={16}>
                    <div className='contentTitle'>
                        <h3>
                            قوانین و مقررات
                        </h3>
                    </div>
                </Grid>
                <Grid container spacing={16} >
                    <div className='contentparag'>
                        <p className='pargcont' >
                            {text}
                        </p>
                    </div>
                </Grid>
                <Grid container spacing={16} >
                    <div className='imagecontent'>
                        <img src='/2.jpg' alt='abot' />
                    </div>
                </Grid>
            </div>
        );
    }
}

